import { mockPaginate } from 'src/mocks/paginate';
import { faker } from '@faker-js/faker';
import { ReadingStatus } from '@dynamika-shared/types/readings.types';

export const generateReaderTask = () => ({
  id: faker.string.uuid(),
  createdDate: faker.date.past().getTime(),
  readingCode: faker.string.alphanumeric(),
  assigneeId: faker.string.uuid(),
  assigneeName: faker.person.fullName(),
  patientId: faker.string.uuid(),
  patientCode: faker.string.alphanumeric(),
  visitId: faker.string.uuid(),
  visitName: faker.string.alphanumeric(),
  visitType: faker.string.alphanumeric(),
  visitEarlyTermination: faker.datatype.boolean(),
  scoringFormCode: faker.string.alphanumeric(),
  startReadingTime: faker.date.past().getTime(),
  finishReadingTime: faker.date.past().getTime(),
  status: faker.helpers.arrayElement([
    ReadingStatus.CREATED,
    ReadingStatus.READING_PENDING,
    ReadingStatus.IN_PROGRESS,
    ReadingStatus.COMPLETED,
    ReadingStatus.TERMINATED,
    ReadingStatus.FAILED,
  ]),
});

const generateReaderTasksData = (n: number) =>
  faker.helpers.multiple(generateReaderTask, { count: n });

export const createPaginatedReaderTaskList = (args: { page: number; size: number }) =>
  mockPaginate(
    generateReaderTasksData(faker.number.int({ min: 10, max: 50 })),
    args
  );
